(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-card-price-alignment"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.sgCardPriceAlignment) return;
    window.sgCardPriceAlignment = true;
    const selector = '.product-card-wrapper > .card:not(.card--horizontal) > .card__content > .card__information > .card-information';
    let frame = 0;
    const widths = new WeakMap();
    const resize = new ResizeObserver(entries => {
      if (entries.some(entry => {
        const width = entry.contentRect.width;
        if (widths.get(entry.target) === width) return false;
        widths.set(entry.target, width);
        return true;
      })) schedule();
    });
    function align() {
      frame = 0;
      const infos = [...document.querySelectorAll(selector)];
      const groups = new Map();
      for (const info of infos) {
        const card = info.closest('.product-card-wrapper');
        if (!card.getClientRects().length || !card.getBoundingClientRect().width) continue;
        const price = info.querySelector('.price');
        if (!price) continue;
        const amount = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item:not(s)');
        if (!amount || !amount.getClientRects().length) continue;
        const cell = card.closest('.grid__item') || card.parentElement;
        const grid = cell.parentElement;
        if (!widths.has(grid)) { widths.set(grid, grid.getBoundingClientRect().width); resize.observe(grid); }
        const rows = groups.get(grid) || [];
        groups.set(grid, rows);
        const top = card.getBoundingClientRect().top;
        let row = rows.find(row => Math.abs(row.top - top) < 3);
        if (!row) { row = { top, entries: [] }; rows.push(row); }
        const previousGap = parseFloat(info.style.getPropertyValue('--sg-price-row-gap')) || 0;
        row.entries.push({ info, previousGap, top: amount.getBoundingClientRect().top - previousGap });
      }
      for (const rows of groups.values()) {
        for (const row of rows) {
          const target = Math.max(...row.entries.map(entry => entry.top));
          for (const entry of row.entries) {
            const gap = target - entry.top;
            const nextGap = gap > .5 ? gap : 0;
            if (Math.abs(nextGap - entry.previousGap) <= .5) continue;
            if (nextGap) entry.info.style.setProperty('--sg-price-row-gap', `${nextGap}px`);
            else entry.info.style.removeProperty('--sg-price-row-gap');
          }
        }
      }
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(align);
    }
    const mutations = new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest('.product-card-wrapper')) return true;
        return [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.product-card-wrapper, .grid__item') || node.querySelector('.product-card-wrapper')));
      })) schedule();
    });
    function start() {
      mutations.observe(document.body, { childList: true, subtree: true, characterData: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('load', event => {
        if (event.target instanceof HTMLImageElement && event.target.closest('.product-card-wrapper')) schedule();
      }, true);
      document.addEventListener('shopify:section:load', schedule);
      document.fonts?.ready.then(schedule);
      schedule();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-care-scroll-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-care-scroll-navigation')) {
  customElements.define('sg-care-scroll-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.init = () => {
        this.main = document.getElementById('MainContent');
        this.nav = this.querySelector('nav');
        this.row = this.querySelector('.sg-care-scroll-links');
        if (!this.main || !this.nav || !this.row) return;
        if (this.dataset.kind === 'auto' && this.main.querySelector('sg-led-navigation, sg-set-navigation, sg-growbox-navigation, sg-accessory-navigation')) {
          this.remove();
          return;
        }
        this.labels = JSON.parse(this.querySelector('script').textContent);
        this.header = document.querySelector('.section-header');
        this.entries = [];
        this.bounds = [];
        this.resolve();
        this.nav.addEventListener('click', event => this.jump(event), {signal});
        window.addEventListener('scroll', this.schedule, {signal, passive:true});
        window.addEventListener('resize', this.schedule, {signal, passive:true});
        window.addEventListener('pageshow', this.schedule, {signal});
        document.addEventListener('shopify:section:load', () => { this.resolve(); this.schedule(); }, {signal});
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.main);
        this.observer.observe(this.nav);
        if (this.header) this.observer.observe(this.header);
        this.mutations = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) { this.resolve(); this.schedule(); }
        });
        this.mutations.observe(this.main, {childList:true, subtree:true});
        this.schedule();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, {signal, once:true});
      else this.init();
    }
    section(key) {
      return [...this.main.children].find(el => el.id === key || el.id.endsWith('__' + key));
    }
    resolve() {
      let kind = this.dataset.kind;
      if (kind === 'auto') {
        if (this.section('soil_details')) kind = 'soil';
        else if (this.section('shopify-section-sg-sensor-product-main')) kind = 'sensor';
        else if (this.section('accordion_collapse_kXzB3j')) kind = 'compact';
        else kind = 'care';
      }
      this.productSection = this.section(kind === 'sensor' ? 'shopify-section-sg-sensor-product-main' : 'main');
      if (!this.productSection) this.productSection = this.main.querySelector('product-info')?.closest('.shopify-section');
      const definitions = [{key:'overview', get:() => this.productSection?.querySelector('h1')}];
      const add = (key, section, selector = 'h2, h3') => definitions.push({key, get:() => this.section(section)?.querySelector(selector)});
      if (kind === 'soil') {
        add('highlights','soil_details','[id^="SoilHeading-"][id$="-overview"]');
        add('technical','soil_details','[id^="SoilHeading-"][id$="-facts"]');
        add('application','soil_details','[id^="SoilHeading-"][id$="-application"]');
        add('faq','soil_faq');
      } else if (kind === 'compact') {
        add('highlights','accordion_collapse_kXzB3j','#section2 h2');
        add('contents','accordion_collapse_kXzB3j','#section3 h2');
        add('technical','accordion_collapse_kXzB3j','#section4 h2');
        add('faq','sg_product_faq_qa');
      } else if (kind === 'sensor') {
        add('contents','shopify-section-sg-sensor-product-content','h2:nth-of-type(2)');
        add('faq','shopify-section-sg-sensor-product-content','.sg-b2-faq h2');
      } else {
        add('contents','specification_element_26_cBHTQX');
        add('highlights','indoor_grow_T4BcjT');
        add('technical','led_system_Qq86Tq');
        add('application','ventilation_klima_eEPAaB');
        add('faq','fragen_zu_spider_APLPFG');
      }
      if (this.dataset.kind === 'auto' && !definitions.some(definition => definition.key !== 'overview' && definition.get())) {
        const headings = [...(this.main.querySelector('.product__description')?.querySelectorAll('h2, h3') || [])];
        for (const section of this.main.children) {
          if (section === this.productSection || section === this || /related|recommend|support/i.test(section.id)) continue;
          const heading = section.querySelector('h2, h3');
          if (heading && !section.querySelector('product-recommendations, .product-grid')) headings.push(heading);
        }
        for (const [index, heading] of [...new Set(headings)].slice(0, 8).entries()) {
          const label = heading.textContent.trim();
          if (label) definitions.push({key:'section-' + index, label, get:() => heading});
        }
      }
      definitions.push({key:'reviews',get:() => this.main.querySelector('.jdgm-review-widget')});
      const existing = new Map(this.entries.map(entry => [entry.key,entry.link]));
      this.entries = definitions.map(definition => {
        const target = definition.get();
        if (!target) return null;
        const link = existing.get(definition.key) || document.createElement('a');
        link.textContent = definition.label || this.labels[definition.key];
        link.dataset.key = definition.key;
        if (!target.id) target.id = 'sg-care-scroll-' + definition.key;
        link.href = '#' + target.id;
        return {key:definition.key,link,target};
      }).filter(Boolean);
      this.row.replaceChildren(...this.entries.map(entry => entry.link));
      this.bounds = [...this.main.querySelectorAll('.page-width, .sg-soil-details')].filter(el => !this.contains(el) && !this.productSection?.contains(el) && !el.querySelector('.page-width, .sg-soil-details'));
      for (const entry of this.entries) {
        if (entry.key === 'overview' || entry.target.closest('.page-width, .sg-soil-details')) continue;
        let container = entry.target;
        while (container.parentElement && container.parentElement !== this.main) container = container.parentElement;
        if (container.parentElement === this.main && container !== this.productSection && !this.bounds.includes(container)) this.bounds.push(container);
      }
      for (const el of this.bounds) el.classList.add('sg-care-scroll-content');
    }
    update() {
      if (!this.nav || !this.isConnected) return;
      const rect = this.header?.getBoundingClientRect();
      const offset = rect ? Math.max(0,Math.min(rect.bottom,rect.height)) : 0;
      this.style.setProperty('--sg-care-scroll-top',Math.round(offset) + 'px');
      const desktop = innerWidth >= 990 && innerHeight >= 600;
      for (const el of this.bounds) {
        const inset = Math.max(0,176 - el.getBoundingClientRect().left) + 'px';
        if (desktop && el.style.getPropertyValue('--sg-care-scroll-inset') !== inset) el.style.setProperty('--sg-care-scroll-inset',inset);
        else if (!desktop) el.style.removeProperty('--sg-care-scroll-inset');
      }
      this.toggleAttribute('data-side',desktop);
      this.style.setProperty('--sg-care-scroll-left','16px');
      const usable = this.entries.filter(entry => entry.target.isConnected && entry.target.getClientRects().length && entry.target.getBoundingClientRect().height > 0);
      for (const entry of this.entries) entry.link.hidden = !usable.includes(entry);
      const contentStart = Math.min(...usable.filter(entry => entry.key !== 'overview').map(entry => entry.target.getBoundingClientRect().top));
      const revealEdge = offset + (desktop ? 0 : this.nav.offsetHeight) + 24;
      const passed = contentStart <= revealEdge || (this.productSection && this.productSection.getBoundingClientRect().bottom <= revealEdge);
      const visible = scrollY > 300 && passed && usable.length > 1;
      this.toggleAttribute('data-visible',visible);
      this.nav.inert = !visible;
      const threshold = offset + (desktop ? 0 : this.nav.offsetHeight) + 24;
      let current = usable[0];
      for (const entry of usable) if (entry.target.getBoundingClientRect().top <= threshold) current = entry;
      for (const entry of usable) {
        if (entry === current) entry.link.setAttribute('aria-current','location');
        else entry.link.removeAttribute('aria-current');
      }
    }
    jump(event) {
      const link = event.target.closest('a[data-key]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const entry = this.entries.find(item => item.link === link);
      if (!entry?.target.isConnected) return;
      event.preventDefault();
      for (let parent = entry.target.parentElement; parent && parent !== this.main; parent = parent.parentElement) if (parent.tagName === 'DETAILS') parent.open = true;
      const header = this.header?.getBoundingClientRect();
      const offset = (header ? Math.max(0,Math.min(header.bottom,header.height)) : 0) + (this.hasAttribute('data-side') ? 0 : this.nav.offsetHeight) + 16;
      entry.target.setAttribute('tabindex','-1');
      entry.target.focus({preventScroll:true});
      window.scrollTo({top:Math.max(0,scrollY + entry.target.getBoundingClientRect().top - offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.mutations?.disconnect();
      for (const el of this.bounds || []) { el.classList.remove('sg-care-scroll-content'); el.style.removeProperty('--sg-care-scroll-inset'); }
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-cart-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-cart-extras')) {
    customElements.define('sg-cart-extras', class extends HTMLElement {
      static pending = false;
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('submit', event => this.add(event));
      }
      async add(event) {
        const form = event.target.closest('.sg-cart-extra__form');
        if (!form) return;
        event.preventDefault();
        if (this.constructor.pending) return;
        this.constructor.pending = true;
        const button = form.querySelector('button');
        const label = button.textContent;
        const error = this.querySelector('[role="alert"]');
        error.hidden = true;
        const locked = [...document.querySelectorAll('sg-cart-extras button, .cart__checkout-button')].filter(el => !el.disabled);
        locked.forEach(el => { el.disabled = true; });
        button.textContent = this.dataset.adding;
        this.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        let added = false;
        try {
          const drawer = document.querySelector('cart-drawer');
          const inDrawer = this.dataset.context === 'drawer';
          const targets = ['main-cart-items', 'main-cart-footer'].map(id => document.getElementById(id)).filter(Boolean);
          const sectionIds = [...new Set(['cart-icon-bubble', ...(drawer ? ['cart-drawer'] : []), ...targets.map(el => el.dataset.id)])];
          const data = new FormData(form);
          data.set('sections', sectionIds.join(','));
          data.set('sections_url', window.location.pathname);
          const response = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data, signal: controller.signal });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(typeof state.description === 'string' ? state.description : this.dataset.error);
          added = true;
          if (!state.sections || sectionIds.some(id => !state.sections[id])) {
            window.location.assign(window.routes.cart_url);
            return;
          }
          const parser = new DOMParser();
          for (const target of targets) {
            const source = parser.parseFromString(state.sections[target.dataset.id], 'text/html').getElementById(target.id);
            if (!source) throw new Error(this.dataset.error);
            target.innerHTML = source.innerHTML;
            target.classList.remove('is-empty');
          }
          if (inDrawer && drawer) {
            drawer.renderContents(state);
          } else {
            const bubble = document.getElementById('cart-icon-bubble');
            const source = parser.parseFromString(state.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (bubble && source) bubble.innerHTML = source.innerHTML;
            if (drawer) {
              const fresh = parser.parseFromString(state.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
              if (fresh) {
                drawer.querySelector('#CartDrawer').innerHTML = fresh.innerHTML;
                drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
              }
            }
            document.getElementById('checkout')?.focus({ preventScroll: true });
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: data.get('id'), cartData: state });
          }
        } catch (cause) {
          if (added) {
            window.location.assign(window.routes.cart_url);
            return;
          }
          error.textContent = cause instanceof TypeError || cause.name === 'AbortError' ? this.dataset.error : (cause.message || this.dataset.error);
          error.hidden = false;
        } finally {
          clearTimeout(timeout);
          locked.forEach(el => { el.disabled = false; });
          button.textContent = label;
          this.removeAttribute('aria-busy');
          this.constructor.pending = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
